import React, { Component } from 'react'
import Movie from './Movie'


import styled from 'styled-components'
const MovieGrid = styled.div`
    display: grid;
    grid-gap:20px;
    grid-template-columns: repeat(5, 2fr);

    @media only screen and (max-width: 768px){
      grid-template-columns: repeat(2, 2fr);
    }

    @media only screen and (max-width: 600px){
      grid-template-columns: repeat(1, 2fr);
    }
`;


export default class MovieList extends Component{

  state = {
    movies: []
  }
  async componentDidMount() {
    try{
      const res = await fetch('https://api.themoviedb.org/3/discover/movie?api_key=168a55cfe2647c9a3c7d87da50877434&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1')

      const movies = await res.json()

      console.log(movies)
      this.setState({
        movies: movies.results
      })
    }catch(e){
      console.log(e)
    }
  }

  render(){
    return(
      <MovieGrid className="container">
        { this.state.movies.map( (movie) => <Movie 
                                        key={movie.id} 
                                        movie={movie} 
                                        desc={movie.desc}
                                        />  )}
      </MovieGrid>
    )
  }
} 





// WEBPACK FOOTER //
// ./src/components/Movies/MovieList.js